<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/investidor/batches/${$route.params.idBatch}/startups`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para as startups
              do batch</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div
          class="col-lg-4 order-lg-1 order-md-0 vld-parent d-flex align-items-stretch"
          ref="card_startup"
        >
          <startup-batch-info
            v-if="batch && startup"
            :startup="startup"
            :batch="batch"
            basePage="investidor"
            class="flex-grow-1"
          />
        </div>
        <div
          class="col-lg-8 mt-lg-0 mt-3 vld-parent d-flex align-items-stretch"
          ref="card_stats"
        >
          <card shadow type="secondary" class="flex-grow-1">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    Painel mensal da Startup -
                    <span class="text-warning">{{
                      startup.name || "..."
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-12">
              <startup-metrics
                :data="startup.responses"
                title="Indicadores de desempenho do último mês"
              />
            </div>
          </card>
        </div>
      </div>
      <div class="row mt-3" v-if="cards.length">
        <div class="col-lg-12">
          <card shadow type="secondary">
            <div class="col-12">
              <CustomCardList :data="cards" />
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StartupBatchInfo from "@/components/StartupDashboard/StartupBatchInfo";
import StartupMetrics from "@/components/StartupDashboard/StartupMetrics";
import CustomCardList from "@/components/CustomCardList";

import api from "@/services/api";

export default {
  name: "investidor_acompanhamento",
  components: {
    StartupBatchInfo,
    StartupMetrics,
    CustomCardList,
  },
  data() {
    return {
      batch: "",
      startup: "",
      cards: "",
    };
  },
  async mounted() {
    const loaderStartup = this.$loading.show({
      container: this.$refs.card_startup,
      width: 140,
      height: 140,
    });
    const loaderStats = this.$loading.show({
      container: this.$refs.card_stats,
      width: 140,
      height: 140,
    });
    try {
      const { data } = await api.get(
        `/investor-batch-startup/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}`
      );
      if (!data.batch) throw new Error("Batch not found");
      if (!data.startup) throw new Error("Startup not found");
      this.batch = data.batch;
      this.startup = data.startup;
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!this.startup.logo) this.startup.logo = { url: defaultLogoPath };
      loaderStartup.hide();
      loaderStats.hide();
      await this.loadCards();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao carregar informações");
      this.$router.push(
        `/investidor/batches/${this.$route.params.idBatch}/startups`
      );
    }
  },
  methods: {
    async loadCards() {
      try {
        const { data: cards } = await api.get(
          `/investor-batch-startup/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}/cards`
        );
        if (cards.length) this.cards = cards;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao carregar os cards");
      }
    },
  },
};
</script>
